module.exports = __webpack_public_path__ + "static/media/aq.d9662482.svg";